import React, { FC } from 'react';
import { motion, Variants } from 'framer-motion';
import { ROUTE_CONTAINER_SETTINGS, ROUTE_VARIANTS } from '../../utils';
import { Redirect, Route } from 'react-router';
import { LoadingPage } from '../Loading';

type ScreenProps = {
  loading?: boolean;
  error?: string | null;
  className?: string;
  testId?: string;
  variants?: Variants;
};

export const AnimatedScreen: FC<ScreenProps> = ({
  testId,
  className,
  loading = false,
  error,
  children,
  variants = ROUTE_VARIANTS,
}) => (
  <motion.div
    key="content"
    className={className}
    data-testid={testId}
    {...ROUTE_CONTAINER_SETTINGS}
  >
    {loading ? (
      <LoadingPage />
    ) : error ? (
      <div key="error">{error}</div>
    ) : (
      <motion.div key="content" variants={variants}>
        {children}
      </motion.div>
    )}
  </motion.div>
);

type RedirectProps = {
  to: string;
  from: string;
};

export const AnimatedRedirect: FC<RedirectProps> = ({ to, from }) => (
  <Route
    render={() => (
      <AnimatedScreen>
        <Redirect from={from} to={to} />
      </AnimatedScreen>
    )}
  />
);
